// Delegation also covers slides replaced by Shopify variant and editor updates.
if (!window.ofitGalleryZoomInstalled) {
  window.ofitGalleryZoomInstalled = true;
  const desktop = matchMedia('(min-width:801px) and (hover:hover) and (pointer:fine)');
  const selector = '.product-information__media slideshow-slide .product-media:has(>img:only-child)';
  let active;
  function reset() {
    active?.style.removeProperty('--zoom-x');
    active?.style.removeProperty('--zoom-y');
    active = undefined;
  }
  document.addEventListener('pointermove', event => {
    if (!desktop.matches || event.pointerType !== 'mouse') { reset(); return; }
    const media = event.target.closest?.(selector);
    if (media !== active) reset();
    if (!media) return;
    active = media;
    const rect = media.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    const clamp = value => Math.max(0, Math.min(100, value));
    media.style.setProperty('--zoom-x', `${clamp((event.clientX - rect.left) / rect.width * 100)}%`);
    media.style.setProperty('--zoom-y', `${clamp((event.clientY - rect.top) / rect.height * 100)}%`);
  }, { passive: true });
  document.addEventListener('pointerout', event => {
    if (active && !active.contains(event.relatedTarget)) reset();
  }, { passive: true });
  desktop.addEventListener('change', reset);
  window.addEventListener('blur', reset);
}
